import { useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { AnimatePresence, motion } from "framer-motion"
import PrevPageBtn from "../buttons/PrevPageBtn"
import SearchBox from "./search-box"
import LibraryTabBtn from "./library-tab-btn"
import QrModal from "@/components/modal/Qr"
import useOrientation from "@/hooks/useOrientation"
import { useRouteTitle } from "./hooks/use-route-title"
import { topnavAnimation } from "./hooks/topnav.constants"
import { TopnavShell } from "./components/topnav-shell"
import { TopnavActions } from "./components/topnav-actions"
import { TopnavRouteTitle } from "./components/topnav-route-title"
import { Target, Gauge } from "lucide-react"
import { useNativeVibration } from "@/hooks/useNativeVibration"

// ⭐ ESTA ES LA CLAVE
const MotionLink = motion(Link)

type Props = {
  search?: boolean
  tabButtons?: boolean
}

function Topnav({
  search = false,
  tabButtons = false,
}: Props) {
  const title = useRouteTitle()
  const { isPortrait, isLandscape } = useOrientation()
  const [showQrModal, setShowQrModal] = useState(false)

  const location = useLocation()
  const isHome = location.pathname === "/"

  const vibrate = useNativeVibration()

  return (
    <TopnavShell>
      <div className="flex items-center gap-2">

        {isPortrait && isHome ? (
          <div className="flex items-center gap-2">

            {/* ⭐ FAVORITOS */}
            <MotionLink
              to="/favoritos"
              variants={topnavAnimation}
              initial="initial"
              animate="animate"
              exit="exit"
              onClick={() => vibrate("light")}
              className="
                relative flex items-center justify-center
                w-fit h-9 px-3 rounded-2xl
                border border-[var(--soft-border)]
                bg-[var(--soft-bg)]
                backdrop-blur-xl
                opacity-90 text-[var(--primary-color)]
                text-[.65rem] active:scale-95
              "
            >
              Favoritos
            </MotionLink>

            {/* ⭐ DESCARGAS */}
            <MotionLink
              to="/offline"
              variants={topnavAnimation}
              initial="initial"
              animate="animate"
              exit="exit"
              onClick={() => vibrate("light")}
              className="
                relative flex items-center justify-center
                w-fit h-9 px-3 rounded-2xl
                border border-[var(--soft-border)]
                bg-[var(--soft-bg)]
                backdrop-blur-xl
                opacity-90 text-[var(--primary-color)]
                text-[.65rem] active:scale-95
              "
            >
              Descargas
            </MotionLink>

            {/* ⭐ INSIGHTS */}
            <MotionLink
              to="/insights"
              variants={topnavAnimation}
              initial="initial"
              animate="animate"
              exit="exit"
              onClick={() => vibrate("light")}
              className="
                relative flex items-center justify-center
                w-fit h-9 px-3 rounded-2xl
                border border-[var(--soft-border)]
                bg-[var(--soft-bg)]
                backdrop-blur-xl
                opacity-90 text-[var(--primary-color)]
                text-[.65rem] active:scale-95
              "
            >
              <Gauge className="w-4 h-4" /> {/* Target */}
            </MotionLink>

          </div>
        ) : (
          <PrevPageBtn />
        )}

        {search && <SearchBox />}
        {tabButtons && <LibraryTabBtn />}
      </div>

      <TopnavRouteTitle title={title} />

      <TopnavActions
        isPortrait={isPortrait}
        isLandscape={isLandscape}
        onOpenQr={() => setShowQrModal(true)}
      />

      <AnimatePresence>
        {showQrModal && (
          <QrModal
            isVisible={showQrModal}
            setIsVisible={setShowQrModal}
          />
        )}
      </AnimatePresence>

    </TopnavShell>
  )
}

export default Topnav